import React from "react";
import useGameStore from "../store/gameStore";
import GameLogo from "../assets/game_logo.svg";

function StartMenu() {
  const multiplier = useGameStore((s) => s.multiplier);
  const setMultiplier = useGameStore((s) => s.setMultiplier);
  const startGame = useGameStore((s) => s.startGame);

  let bgColor = "#8ade63";
  let easySize = "28px";
  let medSize = "28px";
  let hardSize = "28px";
  let difficulty = "easy";

  if (multiplier === 1) {
    difficulty = "easy";
    bgColor = "#8ade63";
    easySize = "28px";
    medSize = "19px";
    hardSize = "19px";
  } else if (multiplier === 2) {
    difficulty = "medium";
    bgColor = "#ff7918";
    easySize = "19px";
    medSize = "28px";
    hardSize = "19px";
  } else if (multiplier === 3) {
    difficulty = "hard";
    bgColor = "#ff3939";
    easySize = "19px";
    medSize = "19px";
    hardSize = "28px";
  }

  const clickEasy = () => {
    if (multiplier !== 1) setMultiplier(1);
  };

  const clickMed = () => {
    if (multiplier !== 2) setMultiplier(2);
  };

  const clickHard = () => {
    if (multiplier !== 3) setMultiplier(3);
  };

  return (
    <div
      style={{
        zIndex: "4",
        width: "350px",
        height: "600px",
        backgroundColor: "#d9d9d9",
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        borderRadius: "45px",
        padding: "50px",
        paddingBottom: "130px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <img
        className="game-logo"
        src={GameLogo}
        alt="ROYGBV"
        style={{
          width: "100%",
          aspectRatio: "201 / 160",
          objectFit: "contain",
        }}
      />
      <button
        onClick={startGame}
        style={{
          boxSizing: "border-box",
          width: "90%",
          fontFamily: "Jua, sans-serif",
          fontSize: "30px",
          textAlign: "center",
          padding: "7px",
          backgroundColor: "#2F2F2F",
          borderRadius: "25px",
          border: `3px solid ${bgColor}`,
          cursor: "pointer",
          color: `${bgColor}`,
          boxShadow: `0px 0px 18px 1px ${bgColor}`,
        }}
      >
        start!
      </button>
      <div>
        <div
          style={{
            width: "175px",
            height: "5px",
            backgroundColor: `${bgColor}`,
            marginTop: "15%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            transition: "200ms",
          }}
        >
          <button
            style={{
              borderRadius: "50%",
              height: `${easySize}`,
              width: `${easySize}`,
              backgroundColor: `${bgColor}`,
              cursor: "pointer",
              border: "none",
              transition: "200ms",
            }}
            onClick={clickEasy}
          />
          <button
            style={{
              borderRadius: "50%",
              height: `${medSize}`,
              width: `${medSize}`,
              backgroundColor: `${bgColor}`,
              cursor: "pointer",
              border: "none",
              transition: "200ms",
            }}
            onClick={clickMed}
          />
          <button
            style={{
              borderRadius: "50%",
              height: `${hardSize}`,
              width: `${hardSize}`,
              backgroundColor: `${bgColor}`,
              cursor: "pointer",
              border: "none",
              transition: "200ms",
            }}
            onClick={clickHard}
          />
        </div>
        <p
          style={{
            fontFamily: "Jua, sans-serif",
            fontSize: "16px",
            color: "#676767",
            marginTop: "15px",
            textAlign: "center",
          }}
        >
          difficulty: {difficulty}
        </p>
      </div>
    </div>
  );
}

export default StartMenu;
